/**
 * File: Card.jsx
 * Path: /src/components/common/Card.jsx
 * Description: Versatile card component for displaying content in a contained, styled box.
 * Key Features: Supports different styles like elevation, gradient, glass effect, and interactive modes.
 * Maintenance Notes: Used throughout the site for consistent content containers.
 */

import React from 'react';
import { motion } from 'framer-motion';

const Card = ({
  children,
  className = '',
  interactive = false,
  gradient = false,
  bordered = false,
  elevated = true,
  glass = false,
  padding = true,
  onClick,
  motionProps = {},
  ...rest
}) => {
  const baseClasses = "rounded-xl overflow-hidden";
  
  const interactiveClasses = interactive 
    ? "transform transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-pointer" 
    : "";

  const elevatedClasses = elevated 
    ? "shadow-md" 
    : "";

  const borderedClasses = bordered 
    ? "border border-dark-100" 
    : "";

  const gradientClasses = gradient 
    ? "bg-gradient-to-br from-primary-50 to-secondary-50" 
    : "";

  const glassClasses = glass 
    ? "glass-effect" 
    : "bg-white";

  const paddingClasses = padding 
    ? "p-6" 
    : "";

  const allClasses = `${baseClasses} ${interactiveClasses} ${elevatedClasses} ${borderedClasses} ${gradientClasses} ${glassClasses} ${paddingClasses} ${className}`;
  
  if (interactive) {
    return (
      <motion.div 
        className={allClasses} 
        onClick={onClick}
        whileHover={{ y: -5 }}
        whileTap={{ scale: 0.98 }}
        {...motionProps}
        {...rest}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div className={allClasses} onClick={onClick} {...rest}>
      {children}
    </div>
  );
};

export default Card;